var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rt-container mobile-matrix-input" },
    _vm._l(_vm.table.rows, function (row, rIndex) {
      return _c(
        "div",
        { key: row.id, staticClass: "card" },
        [
          _c("van-cell", {
            staticClass: "block-title",
            attrs: { title: row.label },
          }),
          _c(
            "van-cell-group",
            { attrs: { border: false } },
            _vm._l(_vm.table.columns, function (col, cIndex) {
              return _c("van-cell", {
                key: col.id,
                attrs: { title: col.label },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (value) {
                        return [
                          _c("el-input", {
                            nativeOn: {
                              input: function ($event) {
                                return _vm.handleChange($event, rIndex, cIndex)
                              },
                            },
                            model: {
                              value: _vm.dataValue[row.id][col.id],
                              callback: function ($$v) {
                                _vm.$set(_vm.dataValue[row.id], col.id, $$v)
                              },
                              expression: "dataValue[row.id][col.id]",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }